import type { LiveConversationStateT } from '@chatbot/shared-types';

const STATE_STYLE: Record<
  LiveConversationStateT,
  { label: string; bgClass: string; fgClass: string }
> = {
  bot_active: {
    label: 'Con bot',
    bgClass: 'bg-info-50 dark:bg-info-900/20',
    fgClass: 'text-info-700 dark:text-info-300',
  },
  pending_human: {
    label: 'Esperando',
    bgClass: 'bg-warning-50 dark:bg-warning-900/20',
    fgClass: 'text-warning-700 dark:text-warning-300',
  },
  human_active: {
    label: 'En atención',
    bgClass: 'bg-success-50 dark:bg-success-900/20',
    fgClass: 'text-success-700 dark:text-success-300',
  },
  resolved: {
    label: 'Resuelta',
    bgClass: 'bg-surface-sunken',
    fgClass: 'text-content-secondary',
  },
};

export function StateBadge({ state }: { state: LiveConversationStateT }) {
  const s = STATE_STYLE[state] ?? {
    label: state,
    bgClass: 'bg-surface-sunken',
    fgClass: 'text-content-secondary',
  };
  return (
    <span
      className={`px-2 py-0.5 rounded-full text-xs font-medium ${s.bgClass} ${s.fgClass}`}
      aria-label={`Estado: ${s.label}`}
    >
      {s.label}
    </span>
  );
}
